import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Button, Container, Loader } from 'semantic-ui-react';

import ReactHtmlParser from 'react-html-parser';

import '../../css/StudentFeedBackModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import UtilityService from '../../services/UtilityService';

import Modal from '../Modal';

export default
@inject('assignmentManager')
@observer
class StudentFeedbackModal extends Component {
  constructor(props) {
    super(props);
    this.ModalBanner = SatCoreComponent('ModalBanner');
    this.state = {
      feedback: '',
      loadingFeedback: true
    };
  }

  async componentDidMount() {
    const { assignmentManager, assignmentInstanceId, t } = this.props;

    const feedback = await assignmentManager.viewAssignmentFeedback(assignmentInstanceId);

    this.setState({
      feedback: feedback || t('noFeedback'),
      loadingFeedback: false
    });
  }

  cancel = () => {
    this.setState({
      feedback: null
    });

    this.closeStudentFeedbackModal();
  }

  closeStudentFeedbackModal = () => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.closeStudentFeedbackModal();
  }

  render() {
    const { feedbackOpen, t } = this.props;
    const { feedback, loadingFeedback } = this.state;
    const { ModalBanner } = this;

    const transformFn = UtilityService.reactHtmlParserTransform;
    return (
      <>
        <Modal
          className='StudentFeedbackModal EditAssignmentModal'
          closeOnDimmerClick={false}
          closeOnEscape={true}
          onClose={this.cancel}
          open={feedbackOpen}
          size='small'>
          <ModalBanner
            label={t('feedBack', 'Missing view or preview translation')}
            onClose={this.cancel} />
          <Modal.Content scrolling>
            <Container>
              <div className='feedback-text' tabIndex={0}>
                {!loadingFeedback ? (
                  ReactHtmlParser(feedback, { transform: transformFn })
                ) : <Loader active className='modal-loader' inline />}
              </div>
            </Container>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              className='cancelButton'
              onClick={this.cancel}
              primary
              type='button'>
              {t('close')}
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

SatCoreRegister('StudentFeedbackModal', StudentFeedbackModal);
